import { render } from "./FooterFront.vue?vue&type=template&id=09cf3444"
import script from "./FooterFront.vue?vue&type=script&lang=js"
export * from "./FooterFront.vue?vue&type=script&lang=js"

import "./FooterFront.vue?vue&type=style&index=0&id=09cf3444&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__